import React from 'react'
import { Link } from 'react-router-dom';
import Chart from "react-apexcharts";

import { InvestmentData } from './Components/InvestmentData'
import { TotalInvestmentChart } from './Components/TotalInvestmentChart';
import { MonthlyRevenueChart } from './Components/MonthlyRevenueChart';
import { MyInvestmentData } from './Components/MyInvestmentData'
import { TrendingStockColumns, TrendingStockTableData } from './Components/TrendingStockData';

import DataTableHeader from '../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../Common/DataTableFooter/DataTableFooter';

const Investment = () => {
    // {/* x---------------------------------x Trending Stock Table Data x---------------------------------x */ }
    const dataT = TrendingStockTableData.map((data) => {
        return {
            slNo: data.slNo,
            name: data.name,
            price: data.price,
            return: (
                <>
                    <span className={data.text_color}>{data.return}</span>
                </>
            )
        };
    });

    return (
        <div>
            {/* x---------------------------------x Investments Cards Section x---------------------------------x */}
            <div className="row g-3 row-deck justify-content-center">
                {InvestmentData.map((data, index) => {
                    return (
                        <div className="col-lg-4 col-md-6" key={index}>
                            <div className="card border-0 bg-transparent h-100">
                                <div className="card-body rounded-4 bg-white">
                                    <div className="d-flex">
                                        <div className={`card-img avatar lg no-thumbnail rounded-circle me-3 ${data.icon_bg}`}>
                                            {data.icon}
                                        </div>
                                        <div className="card-text">
                                            <p className="text-secondary fs-6 fw-normal  m-0">{data.title}
                                            </p>
                                            <p className="text-dark fs-6 fw-semibold  m-0">{data.amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/* x---------------------------------x Yearly Total Investment / Monthly Revenue x---------------------------------x */}
            <div className="row g-3 row-deck mt-1 mt-sm-3">
                {/* x---------------------------------x Yearly Total Investment x---------------------------------x */}
                <div className="col-lg-6 col-md-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Yearly Total Investment</h3>
                            <Link to="/Investments" className="text-dark text-end fs-6 fw-semibold  d-block d-sm-none">see
                                all</Link>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                            <div style={{ width: "100%", height: "261px", minHeight: "315px" }}
                                id="chart-one">
                                <Chart
                                    options={TotalInvestmentChart}
                                    series={TotalInvestmentChart.series}
                                    type={TotalInvestmentChart.chart.type}
                                    height={TotalInvestmentChart.chart.height}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* x---------------------------------x Monthly Revenue x---------------------------------x */}
                <div className="col-lg-6 col-md-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Monthly Revenue</h3>
                            <Link to="/Investments" className="text-dark text-end fs-6 fw-semibold  d-block d-sm-none">see
                                all</Link>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                            <div style={{ width: "100%", height: "300px" }} id="chart-two">
                                <Chart
                                    options={MonthlyRevenueChart}
                                    series={MonthlyRevenueChart.series}
                                    type={MonthlyRevenueChart.chart.type}
                                    height={MonthlyRevenueChart.chart.height} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x My Investment / Trending Stock x---------------------------------x */}
            <div className="row g-3 row-deck mt-1 mt-sm-3">
                {/* x---------------------------------x My Investment x---------------------------------x */}
                <div className="col-12 mb-sm-2">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">My Investment</h3>
                        </div>
                        <div className="card-body p-0 rounded-4">
                            <ul className="row list-unstyled" id="MyClients">
                                {MyInvestmentData.map((data, index) => {
                                    return (
                                        <li className="col-12" key={index}>
                                            <div className="bg-card p-3 mx-md-3 mx-2 mt-md-3 mt-2 rounded-4">
                                                <div className="row align-items-center">
                                                    <div className="col-lg-5 col-md-12">
                                                        <div className="d-flex gap-4 align-items-center">
                                                            <div className="avatar lg no-thumbnail rounded-circle">
                                                                {data.icon}
                                                            </div>
                                                            <div>
                                                                <h6 className="mb-1">{data.investmentHeading}</h6>
                                                                <span className="text-muted">{data.headingText}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-7 col-md-12">
                                                        <ul className="list-unstyled d-flex justify-content-between mb-0 flex-column flex-md-row align-items-center">
                                                            <li>
                                                                <div className="ms-md-4">
                                                                    <h6 className="mb-1">{data.amount}</h6>
                                                                    <span className="text-muted">{data.amountText}</span>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="ms-md-5 text-start text-md-center">
                                                                    <h6 className={`mb-1 ${data.textColor}`}>{data.numberOfCount}</h6>
                                                                    <span className="text-muted">{data.countText}</span>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <button type="button"
                                                                    className="btn link-offset-2 link-underline link-underline-opacity-0 text-primary"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#exampleModal"
                                                                    data-bs-whatever="@fat">View
                                                                    Details</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* x---------------------------------x Trending Stock x---------------------------------x */}
                <div className="col-12 mt-1 mt-sm-3">
                    <div className="card border-0 bg-transparent ">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Trending Stock</h3>
                            <Link to="/Investments" className="text-dark text-end fs-6 fw-semibold d-block d-sm-none">see
                                all</Link>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                            {/* x---------------------------------x CommonDataTableHeader x---------------------------------x */}
                            <DataTableHeader />

                            {/* x---------------------------------x CommonDataTable x---------------------------------x */}
                            <DataTable columns={TrendingStockColumns} data={dataT} />

                            {/* x---------------------------------x CommonDataTableFooter x---------------------------------x */}
                            <DataTableFooter dataT={"dataT"} />
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x My Invesment POP UP x---------------------------------x */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 text-dark" id="exampleModalLabel">Investment Details</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="card">
                                <div className="card-body pb-0">
                                    <div className="table-responsive">
                                        <table id="loans-table"
                                            className="myDataTable table table-hover m-b-0 "
                                            style={{ width: "100%", }}>
                                            <tbody>
                                                <tr>
                                                    <td>Name:</td>
                                                    <td>Apple Store</td>
                                                </tr>
                                                <tr>
                                                    <td>Type:</td>
                                                    <td>E-commerce, Marketplace</td>
                                                </tr>
                                                <tr>
                                                    <td>Envestment Value:</td>
                                                    <td>$54,000</td>
                                                </tr>
                                                <tr>
                                                    <td>Return Value:</td>
                                                    <td className="text-success">+16</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* x---------------------------------x My Invesment POP UP x---------------------------------x */}
        </div >
    )
}

export default Investment